import React from 'react'
import { Item } from '../../types'


export const SelectContext = React.createContext({
    isOpen: false,
    selectedItem: {} as Item | null,
    disabled: false
})